export class TextUtils {
  static pascalToWords = (input: string): string => input.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (c) => c.toUpperCase());
}
